import { useCallback, useEffect, useState } from 'react';

export const useShowMailSentToast = () => {
    const [showMailSentToast, setShowMailSentToast] = useState(false);

    useEffect(() => {
        const wasMailSent = sessionStorage.getItem('wasMailSent');
        if (wasMailSent) {
            // eslint-disable-next-line react-hooks/set-state-in-effect -- Reads a one-shot flag out of sessionStorage on mount and clears it.
            setShowMailSentToast(true);
            sessionStorage.removeItem('wasMailSent');
        }
    }, []);

    const setWasMailSent = useCallback((value: string) => {
        sessionStorage.setItem('wasMailSent', value);
    }, []);

    return {
        showMailSentToast,
        setShowMailSentToast,
        wasMailSent: sessionStorage.getItem('wasMailSent'),
        setWasMailSent,
    };
};
